<template>
  <v-container id="base" v-if="systemInfoItem != null" fluid tag="section">
    <v-row>
      <v-col class="systemBlock" cols="4">
        <base-material-card
          class="px-5 py-3"
          color="primary"
          :title="$t('disk')"
        >
          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      {{ $t("disk") }} {{ $t("capacity") }} (MB)
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="systemInfoItem.disk.total"
                        :label="$t('total')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="usedDiskPercent"
                        :label="$t('used')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="freeDiskPercent"
                        :label="$t('free')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="12">
                      {{ $t("licensePlate") }} {{ $t("count") }}
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="licensePlateCount.current"
                        :label="$t('current')"
                        readonly
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="licensePlateCount.avaliable"
                        :label="$t('avaliable')"
                        readonly
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4" v-if="false">
                      <v-btn
                        @click="
                          confirmFunction(
                            $t('deleteLicensePlateConfirm'),
                            cleanLicensePlateData
                          )
                        "
                        >{{ $t("clean") }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col class="systemBlock" cols="4">
        <base-material-card
          class="px-5 py-3"
          color="primary"
          :title="$t('cpu')"
        >
          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="systemInfoItem.cpu.model_name"
                    :label="$t('model') + ' ' + $t('name')"
                    readonly
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        v-model="systemInfoItem.cpu.cores"
                        :label="$t('core')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="6">
                      <v-text-field
                        v-model="systemInfoItem.cpu.threads"
                        :label="$t('thread')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col class="systemBlock" cols="4">
        <base-material-card
          class="px-5 py-3"
          color="primary"
          :title="$t('memory')"
        >
          <v-form>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      {{ $t("main") }} {{ $t("memory") }} (MB)
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="systemInfoItem.memory.total"
                        :label="$t('total')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="systemInfoItem.memory.used"
                        :label="$t('used')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="systemInfoItem.memory.free"
                        :label="$t('free')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="12">
                  <v-row>
                    <v-col cols="12">
                      {{ $t("swap") }} {{ $t("memory") }} (MB)
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="systemInfoItem.memory.swap_total"
                        :label="$t('total')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="systemInfoItem.memory.swap_used"
                        :label="$t('used')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>

                    <v-col cols="4">
                      <v-text-field
                        v-model="systemInfoItem.memory.swap_free"
                        :label="$t('free')"
                        readonly
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getSystemInfo } from "@/endpoint/system";
import {
  getLicensePlateCount,
  removeLicensePlate,
} from "@/endpoint/licensePlate";
import { confirmFunction } from "@/plugins/util";

export default {
  name: "Base",
  data() {
    return {
      systemInfoItem: null,
      licensePlateCount: {
        current: 0,
        avaliable: 0,
      },
    };
  },
  created() {
    this.init(this).then((system) => {
      system.usageZeroStuffing();
    });
  },
  computed: {
    usedDiskPercent() {
      let usedPercent = (
        (this.systemInfoItem.disk.used / this.systemInfoItem.disk.total) *
        100
      ).toFixed();

      return this.systemInfoItem.disk.used + " (" + usedPercent + "%)";
    },
    freeDiskPercent() {
      let freePercent = (
        (this.systemInfoItem.disk.free / this.systemInfoItem.disk.total) *
        100
      ).toFixed();

      return this.systemInfoItem.disk.free + " (" + freePercent + "%)";
    },
  },
  methods: {
    removeLicensePlate: removeLicensePlate,
    confirmFunction: confirmFunction,
    async init(scope) {
      scope.systemInfoItem = await getSystemInfo();
      scope.licensePlateCount = await getLicensePlateCount();

      return scope;
    },
    usageZeroStuffing() {
      if (this.systemInfoItem.memory.total == undefined) {
        this.systemInfoItem.memory.total = 0;
      }
      if (this.systemInfoItem.memory.used == undefined) {
        this.systemInfoItem.memory.used = 0;
      }
      if (this.systemInfoItem.memory.free == undefined) {
        this.systemInfoItem.memory.free = 0;
      }
      if (this.systemInfoItem.memory.swap_total == undefined) {
        this.systemInfoItem.memory.swap_total = 0;
      }
      if (this.systemInfoItem.memory.swap_used == undefined) {
        this.systemInfoItem.memory.swap_used = 0;
      }
      if (this.systemInfoItem.memory.swap_free == undefined) {
        this.systemInfoItem.memory.swap_free = 0;
      }
      if (this.systemInfoItem.disk.total == undefined) {
        this.systemInfoItem.disk.total = 0;
      }
      if (this.systemInfoItem.disk.used == undefined) {
        this.systemInfoItem.disk.used = 0;
      }
      if (this.systemInfoItem.disk.free == undefined) {
        this.systemInfoItem.disk.free = 0;
      }
    },
    cleanLicensePlateData() {
      this.removeLicensePlate().then(() => {
        this.$router.go();
      });
    },
  },
};
</script>

<style>
.systemBlock .v-label {
  color: black;
  opacity: 1;
}
</style>